export default __webpack_public_path__ + "static/media/pptls1.a5335ea6.png";